import $ from 'jquery';

$(function () {
  if ($('.culinary-toolkit').length || $('.tile--culinary-toolkit').length) {
    const $toolkitPlayer = $('#toolkit-player');

    $('body').on('click', 'div.tile__media, .tile__video-btn', (event) => {
      const $resource = $(event.currentTarget);
      const { videoId } = $resource.data();

      if (videoId) {
        $toolkitPlayer.attr(
          'src',
          `https://www.youtube.com/embed/${videoId}?feature=oembed&enablejsapi=1`
        );
      }
    });
  }
});

$(function () {
  if (
    $('.presentation-resources').length ||
    $('.single-resource').length ||
    $('.tile--culinary-toolkit').length
  ) {
    const $resourcePlayer = $('#resource-player');

    $('body').on('click', 'button.video-player-btn', (event) => {
      const { videoId, resourceType } = $(event.currentTarget).data();

      const src =
        resourceType === 'id'
          ? `https://www.youtube.com/embed/${videoId}?feature=oembed&enablejsapi=1`
          : videoId;

      if (videoId) $resourcePlayer.attr('src', src);
    });
  }
});
